/**
 * Central SEO site constants.
 *
 * The canonical origin is resolved from the VITE_SITE_URL environment
 * variable so that runtime metadata always uses the real deployed domain.
 * A safe fallback is provided for local development only.
 */
const rawSiteUrl = import.meta.env.VITE_SITE_URL || "https://allchinabuyspread.lat";

export const SITE_URL = rawSiteUrl.replace(/\/+$/, "");

export const SITE_NAME = "AllChinaBuy Spreadsheet";

export const FAVICON_URL =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/49750b7389edabeda6497a215e0702e5.png";

export const LAST_MODIFIED = "2026-08-25";